export default __webpack_public_path__ + "static/media/comics.4696123a.svg";